<script setup lang="ts">
/**
 * UI-kit component
 * Category: Indicators
 * Name: IndicatorPulse
 * FIGMA:
 */
import type { IndicatorPulseProps } from '../types/interfaces'

defineOptions({
  name: 'IndicatorPulse',
})

withDefaults(defineProps<IndicatorPulseProps>(), {
  color: 'blue',
})

const emit = defineEmits<{
  click: []
}>()
</script>

<template>
  <button
    type="button"
    :class="['indicator-pulse', `indicator-pulse--${color}`]"
    :aria-label="label"
    @click.stop="emit('click')"
  >
    <span class="indicator-pulse__dot" />
  </button>
</template>

<style lang="scss" scoped src="../styles/_indicator-pulse.scss" />
